import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-modal-schedule',
    templateUrl: './modal-schedule.component.html',
    styleUrls: ['./modal-schedule.component.scss'],
    standalone: false
})
export class ModalScheduleComponent implements OnInit {

  dateNow = new Date();

  constructor() { }

  ngOnInit() {}

} 
